import { Typography } from '@workspace/ui/common';
import { processHeading } from '@workspace/lib/heading-utils';
import { ProductSlideshowSlide } from '../product-slideshow.types';

interface ProductSlideshowTextSectionProps {
  slide: ProductSlideshowSlide;
}

export function ProductSlideshowTextSection({ slide }: ProductSlideshowTextSectionProps) {
  const headingValue =
    typeof slide.heading === 'string' || typeof slide.heading === 'object' ? slide.heading : undefined;
  const subHeadingValue =
    typeof slide.subheading === 'string' || typeof slide.subheading === 'object' ? slide.subheading : undefined;

  const { text: resolvedHeadingText } = processHeading(headingValue);
  const { text: resolvedSubHeadingText } = processHeading(subHeadingValue);
  const description = typeof slide.description === 'string' ? slide.description : '';

  if (!resolvedHeadingText) {
    return null;
  }

  return (
    <div className="text-container w-full flex flex-col">
      {resolvedSubHeadingText && (
        <Typography
          variant="h3"
          className="text-primary text-left w-full md:max-w-131 wrap-break-word mb-4"
          styleVariant="h5"
        >
          {resolvedSubHeadingText}
        </Typography>
      )}
      {resolvedHeadingText && (
        <Typography variant="h2" className="  text-left w-full wrap-break-word mb-2">
          {resolvedHeadingText}
        </Typography>
      )}

      {description && description.length > 0 && (
        <div className="prose prose-lg max-w-none font-openSans">
          <Typography variant="bodyMd" className="mb-4 last:mb-0 ">
            {description}
          </Typography>
        </div>
      )}
    </div>
  );
}
